import { render, staticRenderFns } from "./ProvinceBranchOffices.vue?vue&type=template&id=f45b8e92&scoped=true&"
import script from "./ProvinceBranchOffices.vue?vue&type=script&lang=js&"
export * from "./ProvinceBranchOffices.vue?vue&type=script&lang=js&"
import style0 from "./ProvinceBranchOffices.vue?vue&type=style&index=0&id=f45b8e92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45b8e92",
  null
  
)

export default component.exports